import { create } from 'zustand'
import type { UseOtherExpensesProps } from './types'

import {
  getAdditionalExpenses,
  createAdditionalExpenses,
  editAdditionalExpenses,
  removeAdditionalExpense,
  getDetailedSummaryExpenses,
  editDetailedSummaryExpenses,
  getBigNumbersOtherExpenses,
  approvalWorkflowOtherExpenses,
  reverseWorkflowOtherExpenses,
  reversePreviewOtherExpenses,
  releasePreviewOtherExpenses
} from './provider'

export const useOtherExpenses = create<UseOtherExpensesProps>()((set) => ({
  additionalExpensesData: null,
  setAdditionalExpensesData: (data) => set({ additionalExpensesData: data }),

  additionalExpensesLoading: false,
  setAdditionalExpensesLoading: (value) => set({ additionalExpensesLoading: value }),

  isAddEditAdditionalExpensesLoading: false,
  setIsAddEditAdditionalExpensesLoading: (value) => set({ isAddEditAdditionalExpensesLoading: value }),

  isRemoveAdditionalExpenseLoading: false,
  setIsRemoveAdditionalExpenseLoading: (value) => set({ isRemoveAdditionalExpenseLoading: value }),

  isDetailedSummaryExpensesLoading: false,
  setIsDetailedSummaryExpensesLoading: (value) => set({ isDetailedSummaryExpensesLoading: value }),

  detailedSummaryExpensesData: null,
  setDetailedSummaryExpensesData: (data) => set({ detailedSummaryExpensesData: data }),

  isEditDetailedSummaryExpensesLoading: false,
  setIsEditDetailedSummaryExpensesLoading: (value) => set({ isEditDetailedSummaryExpensesLoading: value }),

  isBigNumbersOtherExpensesLoading: false,
  setIsBigNumbersOtherExpensesLoading: (value) => set({ isBigNumbersOtherExpensesLoading: value }),

  bigNumbersOtherExpensesData: null,
  setBigNumbersOtherExpensesData: (data) => set({ bigNumbersOtherExpensesData: data }),

  isApprovalWorkflowOtherExpensesLoading: false,
  setIsApprovalWorkflowOtherExpensesLoading: (value) => set({ isApprovalWorkflowOtherExpensesLoading: value }),

  isReverseWorkflowOtherExpensesLoading: false,
  setIsReverseWorkflowOtherExpensesLoading: (value) => set({ isReverseWorkflowOtherExpensesLoading: value }),

  isReversePreviewOtherExpensesLoading: false,
  setIsReversePreviewOtherExpensesLoading: (value) => set({ isReversePreviewOtherExpensesLoading: value }),

  isReleasePreviewOtherExpensesLoading: false,
  setIsReleasePreviewOtherExpensesLoading: (value) => set({ isReleasePreviewOtherExpensesLoading: value }),

  getAdditionalExpenses,
  createAdditionalExpenses,
  editAdditionalExpenses,
  removeAdditionalExpense,
  getDetailedSummaryExpenses,
  editDetailedSummaryExpenses,
  getBigNumbersOtherExpenses,
  approvalWorkflowOtherExpenses,
  reverseWorkflowOtherExpenses,
  reversePreviewOtherExpenses,
  releasePreviewOtherExpenses
}))
